'use strict';

import angular from 'angular';

/**
 * @ngdoc controller
 * @name observatoireApp.controller:ConventionsMiniereController
 * @description
 * # Contrôleur pour la page des conventions minières
 */
angular.module('observatoireApp')
  .controller('ConventionsMiniereController', [
    '$scope', 
    '$state', 
    '$timeout',
    'ConventionsMiniereService',
    'MetaService',
    function($scope, $state, $timeout, ConventionsMiniereService, MetaService) {
      
      // Initialisation des variables
      $scope.conventions = [];
      $scope.conventionsFiltrees = [];
      $scope.Math = window.Math; // Rendre Math disponible dans la vue
      $scope.options = {
        regions: [],
        substances: [],
        statuts: [],
        annees: []
      };
      $scope.filtres = {
        texte: '',
        region: '',
        substance: '',
        statut: '',
        anneeMin: '',
        anneeMax: ''
      };
      $scope.tri = {
        colonne: 'societe',
        ordre: 'asc'
      };
      $scope.pagination = {
        pageCourante: 1,
        elementsParPage: 10,
        totalPages: 1
      };
      $scope.loading = {
        conventions: true,
        map: true,
        details: false
      };
      $scope.conventionSelectionnee = null;
      $scope.carte = null;
      $scope.markers = [];
      $scope.markerGroup = null;
      
      // Définir les métadonnées de la page
      MetaService.setTitle('Conventions minières au Tchad');
      MetaService.setDescription('Base de données des conventions minières signées entre l\'État tchadien et les compagnies minières.');
      
      /**
       * Chargement des données
       */
      $scope.chargerConventions = function() {
        $scope.loading.conventions = true;
        
        ConventionsMiniereService.getConventions()
          .then(function(conventions) {
            $scope.conventions = conventions;
            $scope.conventionsFiltrees = [...conventions];
            $scope.extraireOptionsFiltre();
            $scope.calculerTotalPages();
            $scope.loading.conventions = false;
            
            // Initialisation de la carte après le chargement des données
            $scope.initialiserCarte();
          })
          .catch(function(error) {
            console.error('Erreur lors du chargement des conventions:', error);
            $scope.loading.conventions = false;
          });
      };
      
      /**
       * Calcule le nombre total de pages pour la pagination
       */
      $scope.calculerTotalPages = function() {
        $scope.pagination.totalPages = Math.ceil($scope.conventionsFiltrees.length / $scope.pagination.elementsParPage);
        
        // S'assurer que la page courante est valide
        if ($scope.pagination.pageCourante > $scope.pagination.totalPages) {
          $scope.pagination.pageCourante = 1;
        }
      };
      
      /**
       * Gère le changement du nombre d'éléments par page
       */
      $scope.changerElementsParPage = function() {
        // Convertir la valeur en nombre entier
        $scope.pagination.elementsParPage = parseInt($scope.pagination.elementsParPage, 10);
        // Recalculer le nombre total de pages
        $scope.calculerTotalPages();
        // Revenir à la première page
        $scope.pagination.pageCourante = 1;
      };
      
      /**
       * Extrait les options uniques pour les filtres
       */
      $scope.extraireOptionsFiltre = function() {
        // Extraction des régions uniques
        $scope.options.regions = [...new Set($scope.conventions.map(c => c.region))].filter(Boolean).sort();
        
        // Extraction des substances uniques
        $scope.options.substances = [...new Set($scope.conventions.map(c => c.substance))].filter(Boolean).sort();
        
        // Extraction des statuts uniques
        $scope.options.statuts = [...new Set($scope.conventions.map(c => c.statut))].filter(Boolean).sort();
        
        // Extraction des années uniques
        $scope.options.annees = [...new Set($scope.conventions.map(c => {
          if (!c.dateSignature) return null;
          return new Date(c.dateSignature).getFullYear();
        }))].filter(Boolean).sort();
      };
      
      /**
       * Filtre les conventions selon les critères sélectionnés
       */
      $scope.rechercherConventions = function() {
        // Réinitialiser la pagination
        $scope.pagination.pageCourante = 1;
        
        $scope.conventionsFiltrees = $scope.conventions.filter(function(convention) {
          // Filtre par texte (recherche dans société, projet et substance)
          if ($scope.filtres.texte && $scope.filtres.texte.trim() !== '') {
            const texteRecherche = $scope.filtres.texte.toLowerCase();
            const matchSociete = convention.societe && convention.societe.toLowerCase().includes(texteRecherche);
            const matchProjet = convention.projet && convention.projet.toLowerCase().includes(texteRecherche);
            const matchSubstance = convention.substance && convention.substance.toLowerCase().includes(texteRecherche);
            
            if (!matchSociete && !matchProjet && !matchSubstance) {
              return false;
            }
          }
          
          // Filtre par région
          if ($scope.filtres.region && convention.region !== $scope.filtres.region) {
            return false;
          }
          
          // Filtre par substance
          if ($scope.filtres.substance && convention.substance !== $scope.filtres.substance) {
            return false;
          }
          
          // Filtre par statut
          if ($scope.filtres.statut && convention.statut !== $scope.filtres.statut) {
            return false;
          }
          
          // Filtre par année de début
          if ($scope.filtres.anneeMin && convention.dateSignature) {
            const anneeSignature = new Date(convention.dateSignature).getFullYear();
            if (anneeSignature < parseInt($scope.filtres.anneeMin, 10)) {
              return false;
            }
          }
          
          // Filtre par année de fin
          if ($scope.filtres.anneeMax && convention.dateSignature) {
            const anneeSignature = new Date(convention.dateSignature).getFullYear();
            if (anneeSignature > parseInt($scope.filtres.anneeMax, 10)) {
              return false;
            }
          }
          
          return true;
        });
        
        // Mettre à jour la pagination et la carte après filtrage
        $scope.calculerTotalPages();
        $scope.actualiserCarte();
      };
      
      /**
       * Réinitialisation des filtres
       */
      $scope.reinitialiserFiltres = function() {
        $scope.filtres = {
          texte: '',
          region: '',
          substance: '',
          statut: '',
          anneeMin: '',
          anneeMax: ''
        };
        
        $scope.conventionsFiltrees = [...$scope.conventions];
        $scope.pagination.pageCourante = 1;
        $scope.calculerTotalPages();
        $scope.actualiserCarte();
      };
      
      /**
       * Affiche les détails d'une convention
       * @param {Object|number} conventionParam - La convention ou son ID
       */
      $scope.afficherDetails = function(conventionParam) {
        let convention;
        
        // Si on nous passe directement un ID (depuis le popup de la carte)
        if (typeof conventionParam === 'number' || (typeof conventionParam === 'object' && conventionParam.id)) {
          const id = typeof conventionParam === 'number' ? conventionParam : conventionParam.id;
          convention = $scope.conventions.find(c => c.id === id);
          
          if (!convention) {
            console.error('Convention non trouvée avec l\'ID:', id);
            return;
          }
        } else {
          // C'est un objet convention complet
          convention = conventionParam;
        }
        
        // Rediriger vers la page de détails
        $state.go('main.conventions-minieres-details', { id: convention.id });
      };
      
      /**
       * Change la page courante
       * @param {number} page - Numéro de la page
       */
      $scope.changerPage = function(page) {
        if (page >= 1 && page <= $scope.pagination.totalPages) {
          $scope.pagination.pageCourante = page;
        }
      };
      
      /**
       * Retourne les conventions pour la page courante
       * @returns {Array} - Conventions pour la page courante
       */
      $scope.getConventionsPage = function() {
        const debut = ($scope.pagination.pageCourante - 1) * $scope.pagination.elementsParPage;
        const fin = debut + $scope.pagination.elementsParPage;
        return $scope.conventionsFiltrees.slice(debut, fin);
      };
      
      /**
       * Génère un tableau des numéros de pages à afficher
       * @returns {Array} - Numéros de pages
       */
      $scope.getPages = function() {
        const totalPages = $scope.pagination.totalPages;
        const currentPage = $scope.pagination.pageCourante;
        
        if (totalPages <= 1) {
          return [];
        }
        
        if (totalPages <= 7) {
          // Afficher toutes les pages si leur nombre est <= 7
          return Array.from({ length: totalPages }, (_, i) => i + 1);
        }
        
        // Pour un grand nombre de pages, afficher des ellipses
        const delta = 2; // Nombre de pages autour de la page courante
        const pages = [];
        
        // Toujours afficher la première page
        pages.push(1);
        
        // Gérer l'ellipse de début
        if (currentPage - delta > 2) {
          pages.push('...');
        } else {
          // Si la page courante est proche du début, afficher plus de pages au début
          if (currentPage > 2) {
            pages.push(2);
          }
          if (currentPage > 3) {
            pages.push(3);
          }
        }
        
        // Pages autour de la page courante
        for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
          if (pages[pages.length - 1] !== i - 1 && pages[pages.length - 1] !== '...') {
            pages.push('...');
          }
          pages.push(i);
        }
        
        // Gérer l'ellipse de fin
        if (currentPage + delta < totalPages - 1) {
          if (pages[pages.length - 1] !== totalPages - 2 && pages[pages.length - 1] !== '...') {
            pages.push('...');
          }
        } else {
          // Si la page courante est proche de la fin, afficher plus de pages à la fin
          if (currentPage < totalPages - 2 && !pages.includes(totalPages - 2)) {
            pages.push(totalPages - 2);
          }
          if (currentPage < totalPages - 1 && !pages.includes(totalPages - 1)) {
            pages.push(totalPages - 1);
          }
        }
        
        // Toujours afficher la dernière page
        if (!pages.includes(totalPages)) {
          pages.push(totalPages);
        }
        
        return pages;
      };
      
      /**
       * Tri des résultats
       */
      $scope.trierPar = function(colonne) {
        if ($scope.tri.colonne === colonne) {
          // Inverser l'ordre si on clique sur la même colonne
          $scope.tri.ordre = $scope.tri.ordre === 'asc' ? 'desc' : 'asc';
        } else {
          // Nouvelle colonne, tri ascendant par défaut
          $scope.tri.colonne = colonne;
          $scope.tri.ordre = 'asc';
        }
        
        // Appliquer le tri
        $scope.conventionsFiltrees.sort(function(a, b) {
          let valeurA = a[$scope.tri.colonne];
          let valeurB = b[$scope.tri.colonne];
          
          // Gestion des valeurs null/undefined
          if (valeurA === null || valeurA === undefined) valeurA = '';
          if (valeurB === null || valeurB === undefined) valeurB = '';
          
          // Tri des dates
          if ($scope.tri.colonne === 'dateSignature') {
            valeurA = valeurA ? new Date(valeurA).getTime() : 0;
            valeurB = valeurB ? new Date(valeurB).getTime() : 0;
          }
          
          // Appliquer l'ordre de tri
          if ($scope.tri.ordre === 'asc') {
            return valeurA > valeurB ? 1 : -1;
          } else {
            return valeurA < valeurB ? 1 : -1;
          }
        });
      };
      
      /**
       * Exporte les données au format Excel
       */
      $scope.exporterExcel = function() {
        // Simulation - dans une application réelle, on utiliserait une bibliothèque pour générer un fichier Excel
        console.log('Exportation Excel demandée pour', $scope.conventionsFiltrees.length, 'conventions');
        alert('La fonctionnalité d\'exportation Excel sera implémentée dans une prochaine version.');
      };
      
      /**
       * Imprime la liste des conventions
       */
      $scope.imprimer = function() {
        window.print();
      };
      
      /**
       * Initialise la carte Leaflet pour afficher les conventions minières
       */
      $scope.initialiserCarte = function() {
        $scope.loading.map = true;
        
        // S'assurer que l'élément DOM est prêt
        setTimeout(function() {
          try {
            // Créer la carte si elle n'existe pas déjà
            if (!$scope.carte) {
              $scope.carte = L.map('conventions-map', {
                center: [15.454166, 18.732207], // Coordonnées centrales du Tchad
                zoom: 5,
                minZoom: 4,
                maxZoom: 10
              });
              
              // Ajouter la couche de carte OpenStreetMap
              L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              }).addTo($scope.carte);
              
              // Ajouter une légende
              var legend = L.control({position: 'bottomright'});
              
              legend.onAdd = function(map) {
                var div = L.DomUtil.create('div', 'info legend');
                div.style.backgroundColor = 'white';
                div.style.padding = '10px';
                div.style.border = '1px solid #ccc';
                div.style.borderRadius = '5px';
                
                div.innerHTML += '<h4>Statut des conventions</h4>';
                div.innerHTML += '<div><i style="background: #5cb85c; width: 10px; height: 10px; display: inline-block; border-radius: 50%;"></i> En vigueur</div>';
                div.innerHTML += '<div><i style="background: #f0ad4e; width: 10px; height: 10px; display: inline-block; border-radius: 50%;"></i> En phase d\'exploration</div>';
                div.innerHTML += '<div><i style="background: #d9534f; width: 10px; height: 10px; display: inline-block; border-radius: 50%;"></i> Expiré</div>';
                div.innerHTML += '<div><i style="background: #7F7F7F; width: 10px; height: 10px; display: inline-block; border-radius: 50%;"></i> Suspendu</div>';
                
                return div;
              };
              
              legend.addTo($scope.carte);
            }
            
            // Groupe de marqueurs pour la carte
            if (!$scope.markerGroup) {
              $scope.markerGroup = L.layerGroup().addTo($scope.carte);
            } else {
              $scope.markerGroup.clearLayers();
            }
            
            // Ajouter les marqueurs pour chaque convention
            $scope.actualiserCarte();
          } catch (error) {
            console.error('Erreur lors de l\'initialisation de la carte:', error);
          }
          
          $scope.loading.map = false;
          $scope.$apply();
        }, 500); // Attendre que l'élément DOM soit prêt
      };
      
      /**
       * Met à jour les marqueurs sur la carte en fonction des conventions filtrées
       */
      $scope.actualiserCarte = function() {
        // Vérifier si la carte existe
        if (!$scope.carte || !$scope.markerGroup) return;
        
        // Supprimer tous les marqueurs existants
        $scope.markerGroup.clearLayers();
        
        // Coordonnées approximatives des régions du Tchad (pour simulation)
        const coordRegions = {
          'Mayo-Kebbi Ouest': { lat: 10.3, lng: 15.2 },
          'Mayo-Kebbi Est': { lat: 9.8, lng: 15.8 },
          'Kanem': { lat: 14.0, lng: 15.5 },
          'Tibesti': { lat: 20.5, lng: 17.5 },
          'Ouaddaï': { lat: 13.7, lng: 20.8 },
          'Logone Oriental': { lat: 8.3, lng: 16.2 },
          'Lac': { lat: 13.5, lng: 14.3 },
          'Guéra': { lat: 11.6, lng: 18.4 },
          'Borkou': { lat: 17.8, lng: 19.1 }
        };
        
        // Ajouter un marqueur pour chaque convention filtrée
        $scope.conventionsFiltrees.forEach(function(convention) {
          let coords;
          
          // Utiliser les coordonnées de la région ou des coordonnées aléatoires
          if (coordRegions[convention.region]) {
            coords = coordRegions[convention.region];
            // Ajouter une légère variation pour éviter la superposition exacte
            coords = {
              lat: coords.lat + (Math.random() - 0.5) * 0.5,
              lng: coords.lng + (Math.random() - 0.5) * 0.5
            };
          } else {
            // Coordonnées aléatoires autour du centre du Tchad
            coords = {
              lat: 15.454166 + (Math.random() - 0.5) * 5,
              lng: 18.732207 + (Math.random() - 0.5) * 5
            };
          }
          
          // Définir la couleur du marqueur en fonction du statut
          let markerColor = '#7F7F7F'; // Gris par défaut
          if (convention.statut === 'En vigueur') {
            markerColor = '#5cb85c'; // Vert
          } else if (convention.statut === 'En phase d\'exploration') {
            markerColor = '#f0ad4e'; // Orange
          } else if (convention.statut === 'Expiré') {
            markerColor = '#d9534f'; // Rouge
          }
          
          // Créer une icône personnalisée pour le marqueur
          const markerIcon = L.divIcon({
            className: 'custom-marker',
            html: `<div style="background-color: ${markerColor}; width: 14px; height: 14px; border-radius: 50%; border: 2px solid white;"></div>`,
            iconSize: [14, 14],
            iconAnchor: [7, 7]
          });
          
          // Créer le marqueur avec popup
          const marker = L.marker([coords.lat, coords.lng], {
            icon: markerIcon,
            title: convention.societe
          });
          
          // Contenu du popup
          const popupContent = `
            <div class="marker-popup">
              <h4>${convention.societe || 'Non spécifié'}</h4>
              <p><strong>Projet:</strong> ${convention.projet || 'Non spécifié'}</p>
              <p><strong>Substance:</strong> ${convention.substance || 'Non spécifié'}</p>
              <p><strong>Région:</strong> ${convention.region || 'Non spécifié'}</p>
              <p><strong>Statut:</strong> <span style="color: ${markerColor}">${convention.statut}</span></p>
              <button class="btn btn-xs btn-primary details-btn" 
                      onclick="document.dispatchEvent(new CustomEvent('afficherDetails', {detail: ${convention.id}}))">
                Voir détails
              </button>
            </div>
          `;
          
          marker.bindPopup(popupContent);
          $scope.markerGroup.addLayer(marker);
        });
      };
      
      /**
       * Écoute l'événement personnalisé pour afficher les détails d'une convention depuis la carte
       */
      document.addEventListener('afficherDetails', function(event) {
        const conventionId = event.detail;
        $scope.$apply(function() {
          $scope.afficherDetails(conventionId);
        });
      });
      
      /**
       * Formate une date pour l'affichage
       * @param {Date|string} date - Date à formater
       * @returns {string} - Date formatée
       */
      $scope.formaterDate = function(date) {
        if (!date) return 'N/A';
        
        try {
          const d = new Date(date);
          return d.toLocaleDateString('fr-FR');
        } catch(e) {
          return date;
        }
      };

      
      /**
       * Ferme le modal de détails
       */
      $scope.fermerDetails = function() {
        // Fermer le modal avec l'API Bootstrap
        var el = document.getElementById('modalDetailsConvention');
        if (el) { var m = bootstrap.Modal.getInstance(el); if (m) m.hide(); }
        
        // Réinitialiser les états après la fermeture du modal
        $timeout(function() {
          $scope.conventionSelectionnee = null;
        }, 300); // Laisser le temps à l'animation de fermeture de se terminer
      };
      
      /**
       * Calcule le nombre total de pages pour la pagination
       */
      function updatePagination() {
        $scope.pagination.totalPages = Math.ceil($scope.conventionsFiltrees.length / $scope.pagination.elementsParPage);
        
        // S'assurer que la page courante est valide
        if ($scope.pagination.pageCourante > $scope.pagination.totalPages) {
          $scope.pagination.pageCourante = 1;
        }
      }
      
      /**
       * Trie les conventions selon la colonne spécifiée
       * @param {string} colonne - Nom de la colonne à trier
       */
      $scope.trierPar = function(colonne) {
        if ($scope.tri.colonne === colonne) {
          // Inverser l'ordre si on clique sur la même colonne
          $scope.tri.ordre = $scope.tri.ordre === 'asc' ? 'desc' : 'asc';
        } else {
          // Nouvelle colonne, trier par ordre ascendant par défaut
          $scope.tri.colonne = colonne;
          $scope.tri.ordre = 'asc';
        }
        
        trierConventions();
      };
      
      /**
       * Effectue le tri des conventions selon les critères définis
       */
      function trierConventions() {
        const colonne = $scope.tri.colonne;
        const ordre = $scope.tri.ordre;
        
        $scope.conventionsFiltrees.sort(function(a, b) {
          let valA = a[colonne];
          let valB = b[colonne];
          
          // Traitement spécial pour les dates
          if (colonne === 'dateSignature') {
            valA = new Date(valA).getTime();
            valB = new Date(valB).getTime();
          }
          
          // Comparaison en fonction du type de données
          if (typeof valA === 'string') {
            return ordre === 'asc' 
              ? valA.localeCompare(valB) 
              : valB.localeCompare(valA);
          } else {
            return ordre === 'asc' 
              ? valA - valB 
              : valB - valA;
          }
        });
        
        updatePagination();
      }
      
      /**
       * Change la page courante
       * @param {number} page - Numéro de la page
       */
      $scope.changerPage = function(page) {
        if (page >= 1 && page <= $scope.pagination.totalPages) {
          $scope.pagination.pageCourante = page;
        }
      };
      
      /**
       * Retourne les conventions pour la page courante
       * @returns {Array} - Conventions pour la page courante
       */
      $scope.getConventionsPage = function() {
        const debut = ($scope.pagination.pageCourante - 1) * $scope.pagination.elementsParPage;
        const fin = debut + $scope.pagination.elementsParPage;
        return $scope.conventionsFiltrees.slice(debut, fin);
      };
      
      /**
       * Génère un tableau des numéros de pages à afficher
       * @returns {Array} - Numéros de pages
       */
      $scope.getPages = function() {
        const pages = [];
        const totalPages = $scope.pagination.totalPages;
        const currentPage = $scope.pagination.pageCourante;
        
        // Si moins de 7 pages, afficher toutes les pages
        if (totalPages <= 7) {
          for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
          }
        } else {
          // Toujours inclure la première page
          pages.push(1);
          
          // Calculer le début et la fin des pages à afficher
          let start = Math.max(2, currentPage - 2);
          let end = Math.min(totalPages - 1, currentPage + 2);
          
          // Ajuster si on est près du début
          if (currentPage <= 4) {
            end = 5;
          }
          
          // Ajuster si on est près de la fin
          if (currentPage >= totalPages - 3) {
            start = totalPages - 4;
          }
          
          // Ajouter "..." après la page 1 si nécessaire
          if (start > 2) {
            pages.push('...');
          }
          
          // Ajouter les pages du milieu
          for (let i = start; i <= end; i++) {
            pages.push(i);
          }
          
          // Ajouter "..." avant la dernière page si nécessaire
          if (end < totalPages - 1) {
            pages.push('...');
          }
          
          // Toujours inclure la dernière page
          pages.push(totalPages);
        }
        
        return pages;
      };
      
      /**
       * Exporte les données au format Excel
       */
      $scope.exporterExcel = function() {
        $scope.loading.export = true;
        
        ConventionsMiniereService.exporterExcel($scope.conventionsFiltrees)
          .then(function(response) {
            // Simuler un téléchargement
            const element = document.createElement('a');
            element.href = URL.createObjectURL(response.data);
            element.download = 'Conventions_minieres.xlsx';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
            
            $scope.loading.export = false;
          })
          .catch(function(error) {
            console.error('Erreur lors de l\'exportation Excel:', error);
            alert('Erreur lors de l\'exportation des données. Veuillez réessayer.');
            $scope.loading.export = false;
          });
      };
      
      /**
       * Imprime la liste des conventions
       */
      $scope.imprimer = function() {
        window.print();
      };
      
      /**
       * Initialise la carte Leaflet
       */
      $scope.initialiserCarte = function() {
        $scope.loading.map = true;
        
        // Vérifier si Leaflet est disponible dans l'environnement global
        if (typeof L === 'undefined') {
          console.error('Leaflet n\'est pas disponible (L non défini)');
          $scope.loading.map = false;
          return;
        }
        
        // Vérifier si l'élément existe dans le DOM
        const mapContainer = document.getElementById('conventions-map');
        if (!mapContainer) {
          console.error('Container de carte non trouvé (id: conventions-map)');
          setTimeout($scope.initialiserCarte, 500); // Réessayer après un délai
          $scope.loading.map = false;
          return;
        }

        // Coordonnées du centre du Tchad
        const centerLat = 12.1348;
        const centerLng = 15.0557;
        const defaultZoom = 5;

        // Initialiser la carte
        const map = L.map('conventions-map', {
          center: [centerLat, centerLng],
          zoom: defaultZoom,
          scrollWheelZoom: false
        });

        // Ajouter les couches de fond (tile layers)
        const osmLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors',
          maxZoom: 18
        }).addTo(map);

        const satelliteLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
          attribution: 'Source: Esri, DigitalGlobe, GeoEye, Earthstar Geographics',
          maxZoom: 18
        });

        // Grouper les couches de fond
        const baseMaps = {
          "OpenStreetMap": osmLayer,
          "Satellite": satelliteLayer
        };

        // Créer un groupe de marqueurs avec clustering
        const markers = L.markerClusterGroup();
        
        // Stocker le groupe de marqueurs pour les mises à jour ultérieures
        $scope.markerGroup = markers;
        
        // Ajouter les marqueurs initiaux
        ajouterMarqueurs(markers);
        
        // Ajouter le groupe de marqueurs à la carte
        map.addLayer(markers);
        
        // Ajouter le contrôle des couches
        L.control.layers(baseMaps, {
          "Conventions minières": markers
        }).addTo(map);
        
        // Ajouter une légende
        const legend = L.control({position: 'bottomright'});
        legend.onAdd = function(map) {
          const div = L.DomUtil.create('div', 'info legend');
          div.innerHTML = `
            <div style="background: white; padding: 10px; border-radius: 5px; box-shadow: 0 0 15px rgba(0,0,0,0.2);">
              <h4>Légende</h4>
              <div style="margin-top: 5px;">
                <div style="display: flex; align-items: center; margin-bottom: 5px;">
                  <div style="background-color: #5cb85c; width: 15px; height: 15px; border-radius: 50%; margin-right: 8px;"></div>
                  <span>En vigueur</span>
                </div>
                <div style="display: flex; align-items: center; margin-bottom: 5px;">
                  <div style="background-color: #f0ad4e; width: 15px; height: 15px; border-radius: 50%; margin-right: 8px;"></div>
                  <span>En phase d'exploration</span>
                </div>
                <div style="display: flex; align-items: center; margin-bottom: 5px;">
                  <div style="background-color: #d9534f; width: 15px; height: 15px; border-radius: 50%; margin-right: 8px;"></div>
                  <span>Expiré</span>
                </div>
                <div style="display: flex; align-items: center;">
                  <div style="background-color: #7F7F7F; width: 15px; height: 15px; border-radius: 50%; margin-right: 8px;"></div>
                  <span>Autre (Suspendu)</span>
                </div>
              </div>
            </div>
          `;
          return div;
        };
        legend.addTo(map);
        
        // Stocker la référence de la carte dans $scope pour y accéder plus tard
        $scope.map = map;
        
        $scope.loading.map = false;
        console.log('Carte Leaflet initialisée avec succès pour les conventions minières');
      };
      
      /**
       * Ajoute les marqueurs à la carte
       * @param {L.MarkerClusterGroup} markerGroup - Groupe de marqueurs
       */
      function ajouterMarqueurs(markerGroup) {
        // Vider le groupe de marqueurs existants
        markerGroup.clearLayers();
        
        // Coordonnées approximatives des régions du Tchad (pour simulation)
        const coordRegions = {
          'Mayo-Kebbi Ouest': { lat: 10.3, lng: 15.2 },
          'Mayo-Kebbi Est': { lat: 9.8, lng: 15.8 },
          'Kanem': { lat: 14.0, lng: 15.5 },
          'Tibesti': { lat: 20.5, lng: 17.5 },
          'Ouaddaï': { lat: 13.7, lng: 20.8 },
          'Logone Oriental': { lat: 8.3, lng: 16.2 },
          'Lac': { lat: 13.5, lng: 14.3 },
          'Guéra': { lat: 11.6, lng: 18.4 },
          'Borkou': { lat: 17.8, lng: 19.1 }
        };
        
        // Ajouter un marqueur pour chaque convention filtrée
        $scope.conventionsFiltrees.forEach((convention) => {
          let coords;
          
          // Utiliser les coordonnées de la région ou des coordonnées aléatoires
          if (coordRegions[convention.region]) {
            coords = coordRegions[convention.region];
            // Ajouter une légère variation pour éviter la superposition exacte
            coords = {
              lat: coords.lat + (Math.random() - 0.5) * 0.5,
              lng: coords.lng + (Math.random() - 0.5) * 0.5
            };
          } else {
            // Coordonnées aléatoires autour du centre du Tchad
            coords = {
              lat: 12.1348 + (Math.random() - 0.5) * 5,
              lng: 15.0557 + (Math.random() - 0.5) * 5
            };
          }
          
          const statut = convention.statut || 'Non défini';
          
          // Définir la couleur du marqueur selon le statut
          let markerColor = '#7F7F7F'; // Gris par défaut
          if (statut.includes('vigueur')) {
            markerColor = '#5cb85c'; // Vert
          } else if (statut.includes('exploration')) {
            markerColor = '#f0ad4e'; // Orange
          } else if (statut.includes('Expiré')) {
            markerColor = '#d9534f'; // Rouge
          }
          
          // Créer une icône personnalisée pour le marqueur
          const markerIcon = L.divIcon({
            className: 'custom-marker',
            html: `<div style="background-color: ${markerColor}; width: 20px; height: 20px; border-radius: 50%; border: 2px solid white;"></div>`,
            iconSize: [20, 20],
            iconAnchor: [10, 10]
          });
          
          // Créer le marqueur avec popup
          const marker = L.marker([coords.lat, coords.lng], {
            icon: markerIcon,
            title: convention.societe
          });
          
          // Contenu du popup
          const popupContent = `
            <div class="marker-popup">
              <h4>${convention.societe || 'Non spécifié'}</h4>
              <p><strong>Substance:</strong> ${convention.substance || 'Non spécifié'}</p>
              <p><strong>Région:</strong> ${convention.region || 'Non spécifié'}</p>
              <p><strong>Statut:</strong> <span class="text-${statut.toLowerCase().includes('vigueur') ? 'success' : (statut.toLowerCase().includes('expiré') ? 'danger' : 'warning')}">${statut}</span></p>
              <p><button class="btn btn-sm btn-primary btn-details" onclick="angular.element('#conventions-map').scope().afficherDetails(${convention.id})">Voir détails</button></p>
            </div>
          `;
          
          marker.bindPopup(popupContent);
          markerGroup.addLayer(marker);
        });
      }
      
      /**
       * Met à jour les marqueurs de la carte en fonction des filtres
       */
      $scope.mettreAJourMarqueurs = function() {
        if ($scope.markerGroup && $scope.map) {
          ajouterMarqueurs($scope.markerGroup);
        }
      };
      
      /**
       * Formate une date pour l'affichage
       * @param {Date|string} date - Date à formater
       * @returns {string} - Date formatée
       */
      $scope.formaterDate = function(date) {
        if (!date) return 'N/A';
        
        try {
          const d = new Date(date);
          return d.toLocaleDateString('fr-FR');
        } catch(e) {
          return date;
        }
      };
      
      // Charger les données au démarrage
      $scope.chargerConventions();
    }
  ]);
